import React from 'react';
import useCoralogixMonitoring from '../../hooks/useCoralogixMonitoring';
import { healthMonitor } from '../../utils/healthMonitoring';

const CoralogixDebug: React.FC = () => {
  const {
    logToCoralogix,
    testCoralogixConnection,
    sendHealthLog,
    startHealthMonitoring,
    stopHealthMonitoring,
  } = useCoralogixMonitoring();

  const handleTestLog = () => {
    testCoralogixConnection();
  };

  const handleTestError = () => {
    logToCoralogix(
      new Error('Test error from debug component'),
      { debug: true, component: 'CoralogixDebug' },
      true,
      'Test error message'
    );
  };

  const handleTestInfo = () => {
    logToCoralogix(
      null,
      { debug: true, component: 'CoralogixDebug', type: 'info' },
      true,
      'Test info message'
    );
  };

  const handleHealthLog = () => {
    sendHealthLog('periodic');
  };

  const handleStartHealthMonitoring = () => {
    startHealthMonitoring();
  };

  const handleStopHealthMonitoring = () => {
    stopHealthMonitoring();
  };

  const handleAdvancedHealthLog = () => {
    healthMonitor.logHealth('periodic', {
      additionalData: {
        debug: true,
        component: 'CoralogixDebug',
        sessionDuration: healthMonitor.getSessionDuration(),
      },
    });
  };

  const handleApiCallLog = () => {
    healthMonitor.logApiCall('/test/endpoint', 'GET', 150, 200);
  };

  const handleUserActionLog = () => {
    healthMonitor.logUserAction('button_click', 'CoralogixDebug', 100);
  };

  const handleErrorLog = () => {
    healthMonitor.logError(new Error('Test error from health monitor'), 'debug_component');
  };

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        background: '#333',
        color: 'white',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '12px',
        zIndex: 9999,
      }}
    >
      <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>Coralogix Debug</div>
      <button
        onClick={handleTestLog}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        Test Log
      </button>
      <button
        onClick={handleTestError}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        Test Error
      </button>
      <button
        onClick={handleTestInfo}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        Test Info
      </button>
      <button
        onClick={handleHealthLog}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#ffc107',
          color: 'black',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        Health Log
      </button>
      <button
        onClick={handleStartHealthMonitoring}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#17a2b8',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        Start Health
      </button>
      <button
        onClick={handleStopHealthMonitoring}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        Stop Health
      </button>
      <button
        onClick={handleAdvancedHealthLog}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#e83e8c',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        Adv Health
      </button>
      <button
        onClick={handleApiCallLog}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#fd7e14',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        API Log
      </button>
      <button
        onClick={handleUserActionLog}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#20c997',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        User Action
      </button>
      <button
        onClick={handleErrorLog}
        style={{
          margin: '2px',
          padding: '5px 10px',
          fontSize: '10px',
          background: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
        }}
      >
        Error Log
      </button>
    </div>
  );
};

export default CoralogixDebug;
